import ValentineTemplate from './ValentineTemplate';
import DateNightTemplate from './DateNightTemplate';
import ProposalTemplate from './ProposalTemplate';
import MovieNightTemplate from './MovieNightTemplate';
import AnniversaryTemplate from './AnniversaryTemplate';
import DanceNightTemplate from './DanceNightTemplate';

// Preview images
import valentineImg from '../assets/valentine.png';
import datenightImg from '../assets/datenight.png';
import proposalImg from '../assets/proposal.png';
import movienightImg from '../assets/ticket.png';
import anniversaryImg from '../assets/anniversary.png';
import dancenightImg from '../assets/argentina.png';

// Pattern SVG templates (COLOR_PLACEHOLDER will be replaced with actual color)
const patternSvgs = {
  floral: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 80' width='80' height='80'%3E%3Cpath fill='COLOR_PLACEHOLDER' fill-opacity='0.2' d='M14 16H9v-2h5V9.87a4 4 0 1 1 2 0V14h5v2h-5v15.95A10 10 0 0 0 23.66 27l-3.46-2 8.2-2.2-2.9 5a12 12 0 0 1-21 0l-2.89-5 8.2 2.2-3.47 2A10 10 0 0 0 14 31.95V16zm40 40h-5v-2h5v-4.13a4 4 0 1 1 2 0V54h5v2h-5v15.95A10 10 0 0 0 63.66 67l-3.47-2 8.2-2.2-2.88 5a12 12 0 0 1-21.02 0l-2.88-5 8.2 2.2-3.47 2A10 10 0 0 0 54 71.95V56zm-39 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm40-40a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM15 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm40 40a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'%3E%3C/path%3E%3C/svg%3E")`,
  geometric: `url("data:image/svg+xml,%3Csvg width='180' height='180' viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M81.28 88H68.413l19.298 19.298L81.28 88zm2.107 0h13.226L90 107.838 83.387 88zm15.334 0h12.866l-19.298 19.298L98.72 88zm-32.927-2.207L73.586 78h32.827l.5.5 7.294 7.293L115.414 87l-24.707 24.707-.707.707L64.586 87l1.207-1.207zm2.62.207L74 80.414 79.586 86H68.414zm16 0L90 80.414 95.586 86H84.414zm16 0L106 80.414 111.586 86h-11.172zm-8-6h11.173L98 85.586 92.414 80zM82 85.586L87.586 80H76.414L82 85.586zM17.414 0L.707 16.707 0 17.414V0h17.414zM4.28 0L0 12.838V0h4.28zm10.306 0L2.288 12.298 6.388 0h8.198zM180 17.414L162.586 0H180v17.414zM165.414 0l12.298 12.298L173.612 0h-8.198zM180 12.838L175.72 0H180v12.838zM0 163h16.413l.5.5 7.294 7.293L25.414 172l-8 8H0v-17zm0 10h6.613l-2.334 7H0v-7zm14.586 7l7-7H8.72l-2.333 7h8.2zM0 165.414L5.586 171H0v-5.586zM10.414 171L16 165.414 21.586 171H10.414zm-8-6h11.172L8 170.586 2.414 165zM180 163h-16.413l-7.794 7.793-1.207 1.207 8 8H180v-17zm-14.586 17l-7-7h12.865l2.333 7h-8.2zM180 173h-6.613l2.334 7H180v-7zm-21.586-2l5.586-5.586 5.586 5.586h-11.172zM180 165.414L174.414 171H180v-5.586zm-8 5.172l5.586-5.586h-11.172l5.586 5.586zM152.933 25.653l1.414 1.414-33.94 33.942-1.416-1.416 33.943-33.94zm1.414 127.28l-1.414 1.414-33.942-33.94 1.416-1.416 33.94 33.943zm-127.28 1.414l-1.414-1.414 33.94-33.942 1.416 1.416-33.943 33.94zm-1.414-127.28l1.414-1.414 33.942 33.94-1.416 1.416-33.94-33.943zM0 85c2.21 0 4 1.79 4 4s-1.79 4-4 4v-8zm180 0c-2.21 0-4 1.79-4 4s1.79 4 4 4v-8zM94 0c0 2.21-1.79 4-4 4s-4-1.79-4-4h8zm0 180c0-2.21-1.79-4-4-4s-4 1.79-4 4h8z' fill='COLOR_PLACEHOLDER' fill-opacity='0.15' fill-rule='evenodd'/%3E%3C/svg%3E")`,
  waves: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28' width='56' height='28'%3E%3Cpath fill='COLOR_PLACEHOLDER' fill-opacity='0.2' d='M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z'%3E%3C/path%3E%3C/svg%3E")`,
  crosses: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='COLOR_PLACEHOLDER' fill-opacity='0.2'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
  bubbles: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='96' viewBox='0 0 60 96'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='COLOR_PLACEHOLDER' fill-opacity='0.2'%3E%3Cpath d='M36 10a6 6 0 0 1 12 0v12a6 6 0 0 1-6 6 6 6 0 0 0-6 6 6 6 0 0 1-12 0 6 6 0 0 0-6-6 6 6 0 0 1-6-6V10a6 6 0 1 1 12 0 6 6 0 0 0 12 0zm24 78a6 6 0 0 1-6-6 6 6 0 0 0-6-6 6 6 0 0 1-6-6V58a6 6 0 1 1 12 0 6 6 0 0 0 6 6v24zM0 88V64a6 6 0 0 0 6-6 6 6 0 0 1 12 0v12a6 6 0 0 1-6 6 6 6 0 0 0-6 6 6 6 0 0 1-6 6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
};

// Generate pattern CSS with a specific color
export const getPatternStyle = (patternId, primaryColor) => {
  if (patternId === 'none' || !patternSvgs[patternId]) {
    return {};
  }
  // Convert hex color to URL-encoded format
  const encodedColor = encodeURIComponent(primaryColor);
  const backgroundImage = patternSvgs[patternId].replace(/COLOR_PLACEHOLDER/g, encodedColor);
  return { backgroundImage };
};

// Background patterns for invites (static definitions for UI display)
export const patterns = {
  none: {
    id: 'none',
    name: 'Solid',
  },
  floral: {
    id: 'floral',
    name: 'Floral',
  },
  geometric: {
    id: 'geometric',
    name: 'Geometric',
  },
  waves: {
    id: 'waves',
    name: 'Waves',
  },
  crosses: {
    id: 'crosses',
    name: 'Crosses',
  },
  bubbles: {
    id: 'bubbles',
    name: 'Bubbles',
  },
};

export const defaultPattern = 'floral';

export const templates = {
  valentine: {
    id: 'valentine',
    name: "Will you be my Valentine?",
    description: "Classic Valentine's Day invite with floating hearts",
    defaultQuestion: "Will you be my Valentine?",
    component: ValentineTemplate,
    preview: valentineImg,
    previewEmoji: '\uD83D\uDC95',
    colors: {
      primary: '#ff6b8a',
      secondary: '#ffb6c1',
      background: 'linear-gradient(180deg, #fff0f3 0%, #fc6895 100%)',
    },
  },
  datenight: {
    id: 'datenight',
    name: "Let's go out!",
    description: "Let's take a break from the ordinary and enjoy a special night together.",
    defaultQuestion: "Let's take a break from the ordinary and enjoy a special night together.",
    component: DateNightTemplate,
    preview: datenightImg,
    previewEmoji: '\uD83C\uDF19',
    colors: {
      primary: '#8b5cf6',
      secondary: '#c4b5fd',
      background: 'linear-gradient(180deg, #f2ecff 0%, #b596ff 100%)',
    },
  },
  proposal: {
    id: 'proposal',
    name: "Will you marry me?",
    description: "A Question From the Heart",
    defaultQuestion: "A Question From the Heart",
    component: ProposalTemplate,
    preview: proposalImg,
    previewEmoji: '\uD83D\uDC8D',
    colors: {
      primary: '#ff9500',
      secondary: '#f4e4ba',
      background: 'linear-gradient(180deg, #fff4d2 0%, #ffb6ae 100%)',
    },
  },
  movienight: {
    id: 'movienight',
    name: "Movie Night?",
    description: "Snacks, stories, and a cozy night in",
    defaultQuestion: "Snacks, stories, and a cozy night in",
    component: MovieNightTemplate,
    preview: movienightImg,
    previewEmoji: '\uD83C\uDFAC',
    colors: {
      primary: '#d15b00',
      secondary: '#f39c12',
      background: 'linear-gradient(180deg, #ffbba0 0%, #ffad5c 100%)',
    },
  },
  anniversary: {
    id: 'anniversary',
    name: "Happy Anniversary!",
    description: "Celebrating another year of love, memories, and us.",
    defaultQuestion: "Celebrating another year of love, memories, and us.",
    component: AnniversaryTemplate,
    preview: anniversaryImg,
    previewEmoji: '\uD83D\uDC91',
    colors: {
      primary: '#ea1d61',
      secondary: '#f8bbd9',
      background: 'linear-gradient(180deg, #fff0f5 0%, #fe8f9f 100%)',
    },
  },
  dancenight: {
    id: 'dancenight',
    name: "Dance with me?",
    description: "Lose yourself to dance",
    defaultQuestion: "Lose yourself to dance",
    component: DanceNightTemplate,
    preview: dancenightImg,
    previewEmoji: '\uD83E\uDEA9',
    colors: {
      primary: '#00a8b4',
      secondary: '#e040fb',
      background: 'linear-gradient(180deg, #bbf7ff 0%, #00bcd4 100%)',
    },
  },
};

export { ValentineTemplate, DateNightTemplate, ProposalTemplate, MovieNightTemplate, AnniversaryTemplate, DanceNightTemplate };
